/**
 * Generates a unique request correlation id, consumed by the
 * Logging & Monitoring infrastructure (see docs/architecture/03-monitoring-observability.md).
 */
export function generateRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback for environments without the Web Crypto API.
  return `req-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}
